module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "top-panel skew main-bg-gradient"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('about.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                xxx\n            ")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            XXX\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-486a0984"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/about/pages/index.vue
// module id = 310
// module chunks = 1